
import { ProductModelType } from '@teinor/erp/types/company/product'
import { connect, ConnectedProps } from 'react-redux'
import { ComponentWithPermissions } from '../../../../../../../../../baseComponents/CreateRoutering/types'
import FormRenderer from '../../../../../../../../../forms/FormRenderer'
import { FormRender } from '../../../../../../../../../forms/FormRenderer/types'
import TwinForm from '../../../../../../../../../forms/TwinForm'
import ProductLayout from '../../../../../../../../../specificComponents/Product/ProductLayout'
import { dictionaryComplexFromJsonArr, addDictionaryExtraLine } from '../../../../../../../../../utils/globals/dictionary'
import { valueOrDefaultValue } from '../../../../../../../../../utils/globals/valueOrDefaultValue'
import withLoading from '../../../../../../../../../utils/hoc/withLoading'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../../../utils/reducers'
import { VariantsPayload } from '../../../../../../../../../utils/reducers/products/variants'
import { ProductExtendedTyShort } from '../../../../../../../../../specificComponents/Product/types'

type OtherInformationServiceProps = ComponentWithPermissions & ReduxVariants & {
    basicData: ProductExtendedTyShort
    getData: () => Promise<void>
}

const OtherInformationService: React.FC<OtherInformationServiceProps> = ({ basicData, getData, userPermissions, ...logic }) => {
    const { t } = useTwinTranslation()
    const variantsParsed = dictionaryComplexFromJsonArr(logic.variants?.variants || {})
    const onOff = {
        'on': { name: t('on', 'Activado') },
        'off': { name: t('disabledS', 'Desactivado') },
    }
    const fields: FormRender<ProductModelType> = [
        {
            cols: 2,
            title: t('others', 'Otros'),
            elements: [
                {
                    name: 'VariantGroupMainId',
                    label: t('variantGroupMain', 'Variante principal'),
                    component: 'CustomSelect',
                    items: addDictionaryExtraLine(variantsParsed),
                    sortItems: true
                },
                {
                    name: 'subProductPricesConfig',
                    label: t('subProductPricesParam', 'Precios de los subproductos'),
                    component: 'CustomSelect',
                    items: {
                        'heredate': { name: t('fromParent', 'Del padre') },
                        'self': { name: t('selfPrices', 'Precios propios') },
                        'increment': { name: t('incrementFromParent', 'Incrementar sobre el padre') }
                    }
                },
                {
                    name: 'operateStock',
                    label: t('stockControl', 'Controlar stock'),
                    component: 'CustomSelect',
                    items: addDictionaryExtraLine(onOff),
                    sortItems: true
                },
            ]
        },
        {
            cols: 1,
            title: t('notes', 'Notas'),
            className: 'service_notes',
            elements: [
                {
                    name: 'notes',
                    component: 'TwinEditor',
                    className: 'h-100',
                    defaultValue: basicData?.['notes'] ?? '',
                },
            ]
        },
        {
            cols: 1,
            elements: [
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: basicData?.id
                },
            ]
        }
    ]
    const parsedFields = valueOrDefaultValue(fields, userPermissions, basicData)
    return (
        <TwinForm className='flex flex-auto' action='/api/app/product/updateProduct' onSubmit={() => {getData()}}>
            <ProductLayout basicData={basicData} userPermissions={userPermissions} buttonIsDisabled={false}>
                <FormRenderer sections={parsedFields} antiUnsaveTrigger={true} className='product_container h-1 grid_mincontent' />
            </ProductLayout>
        </TwinForm>
    )
}

const VariantsDispatch = {
    setVariants: (payload: VariantsPayload) => ({ type: 'CHANGE_VARIANTS', payload }),
}

export type ReduxVariants = ConnectedProps<typeof VariantsConnect>
const mapVariantsConnector = (state: AllReduxPayloads) => ({ variants: state.variants })
const VariantsConnect = connect(mapVariantsConnector, VariantsDispatch)

const VariantsConnectLoading = withLoading(OtherInformationService, [{ fetchUrl: '/api/app/product/productVariant/getAllVariantsComplete', propName: 'variants', setFunctionName: 'setVariants' }])

const OtherInformationServiceConnect = VariantsConnect(VariantsConnectLoading)

export default OtherInformationServiceConnect